export default __webpack_public_path__ + "static/media/bank_logo_light.7818c68e.png";